import Cookie from 'js-cookie';
import { requestService } from './utils';

export function getHeaders() {
  return {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'X-CSRF-TOKEN': Cookie.get('csrf'),
  };
}

export function login(username, password) {
  return requestService('/api/v1/login', {
    method: 'post',
    headers: getHeaders(),
    body: JSON.stringify({ user: { username: username, password: password } }),
    credentials: 'include',
  });
}

export function logout() {
  return requestService('/api/v1/logout', {
    method: 'get',
    headers: getHeaders(),
  });
}

export function forgotPassword(email) {
  return requestService('/api/v1/password_resets', {
    method: 'post',
    headers: getHeaders(),
    credentials: 'include',
    body: JSON.stringify({ password_resets: { email: email } }),
  }).then((response) => {
    return response;
  });
}

export function resetPassword({ resetToken, password, passwordConfirmation }) {
  return requestService(`/api/v1/password_resets/${resetToken}`, {
    method: 'PATCH',
    headers: getHeaders(),
    credentials: 'include',
    body: JSON.stringify({
      password_resets: { password: password, password_confirmation: passwordConfirmation },
    }),
  });
}

export function fetchUser() {
  return requestService('/api/v1/users/me', {
    method: 'get',
    headers: getHeaders(),
  }).then((response) => {
    return response;
  });
}
